 (() => {
    const MOBILE_MQ = '(max-width: 767px)';

    class CoucouImageGalleryDetails {
      constructor(section) {
        this.section = section;
        this.slider = section.querySelector('[data-image-gallery-details-slider]');
        this.prev = section.querySelector('.image-gallery-details__mobile-prev');
        this.next = section.querySelector('.image-gallery-details__mobile-next');
        this.current = section.querySelector('.image-gallery-details__mobile-current');
        this.total = section.querySelector('.image-gallery-details__mobile-total');
        this.swiper = null;

        this.mql = window.matchMedia(MOBILE_MQ);
        this.handleMQChange = this.handleMQChange.bind(this);

        if (this.mql.addEventListener) {
          this.mql.addEventListener('change', this.handleMQChange);
        } else if (this.mql.addListener) {
          this.mql.addListener(this.handleMQChange);
        }

        this.syncToViewport();
      }

      handleMQChange() {
        this.syncToViewport();
      }

      syncToViewport() {
        if (this.mql.matches) {
          this.initSwiper();
        } else {
          this.destroySwiper();
        }
      }

      initSwiper() {
        if (!this.slider || this.swiper) return;

        if (typeof Swiper === 'undefined') {
          setTimeout(() => this.initSwiper(), 100);
          return;
        }

        this.swiper = new Swiper(this.slider, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          wrapperClass: 'image-gallery-details__mobile-wrapper',
          slideClass: 'image-gallery-details__mobile-slide',

          navigation: {
            nextEl: this.next,
            prevEl: this.prev,
            disabledClass: 'image-gallery-details__mobile-button-disabled',
          },

          on: {
            init: (swiper) => this.update(swiper),
            slideChange: (swiper) => this.update(swiper),
            reachBeginning: (swiper) => this.update(swiper),
            reachEnd: (swiper) => this.update(swiper),
            fromEdge: (swiper) => this.update(swiper),
          },
        });
      }

      destroySwiper() {
        if (!this.swiper) return;
        try {
          this.swiper.destroy(true, true);
        } catch (e) {}
        this.swiper = null;
      }

      update(swiper) {
        if (this.current) this.current.textContent = swiper.activeIndex + 1;
        if (this.total) this.total.textContent = swiper.slides.length;
        if (this.prev) this.prev.disabled = swiper.isBeginning;
        if (this.next) this.next.disabled = swiper.isEnd;
      }
    }

    const initGalleryDetails = (container = document) => {
      container.querySelectorAll('[data-section-type="image-gallery-details"]').forEach((section) => {
        if (!section.coucouGalleryDetails) {
          section.coucouGalleryDetails = new CoucouImageGalleryDetails(section);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initGalleryDetails());

    document.addEventListener('shopify:section:load', (event) => {
      initGalleryDetails(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-section-type="image-gallery-details"]');
      if (section && section.coucouGalleryDetails) {
        section.coucouGalleryDetails.destroySwiper();
      }
    });
  })();